import $ from 'jquery'
import slick from 'slick-carousel'
import LazyLoad from "vanilla-lazyload"
import ScrollMagic from 'scrollmagic'
import jQueryBridget from 'jquery-bridget'
import ModalVideo from 'modal-video'

/* SETUP SLICK
  ----------------------------- */
export const setupSlideshow = (el, type = 'fullwidth') => {
  const $el = $(el);
  const opts = {
    fullwidth: {
      autoplay: true,
      dots: false,
      arrows: true,
      infinite: true,
      fade: false
    },
    cards: {
      autoplay: true,
      dots: true,
      arrows: false,
      infinite: true,
      fade: false
    }
  }

  $el.slick(opts[type])
}

/* LAZY LOAD
  ----------------------------- */
export const lazyLoad = () => {
  const lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
    data_src: "lazy",
  })
}

/* SMOOTH SCROLL
  ----------------------------- */
export const smoothScroll = () => {
  $('a[href*="#"]:not([href="#"]):not([href="#top"])').click(function() {
    const target = $(this.hash)
    $('html, body').animate({ scrollTop: target.offset().top-60 }, 600)
    return false
  })

  $("a[href='#top']").click(function() {
    $("html, body").animate({ scrollTop: 0 }, 800)
    return false
  })
}

/* HEADER ANIMATION
  ----------------------------- */
export const menuOverlay = () => {
  const toggle = $('.header__toggle')
  const bar = $('.header__toggle .bar')
  const overlay = $('.header--offcanvas, .header__inner, .content-area, body')
  const link = $('.header--offcanvas a');
  const header = $('.header--main');

  toggle.on('click', function () {
    overlay.toggleClass('open')
    bar.toggleClass('animate')
    toggle.toggleClass('open')
  })

  link.on('click', function () {
    overlay.removeClass('open')
    bar.removeClass('animate')
    toggle.removeClass('open')
  })

  window.onresize = () => {
    overlay.removeClass('open')
    bar.removeClass('animate')
    toggle.removeClass('open')
  }

  $(window).scroll(function(e) {
    $(document).scrollTop() > 200 ?
      header.addClass('sticky') :
      header.removeClass('sticky')

    this.oldScroll > this.scrollY ?
      header.addClass('sticky-show').removeClass('sticky-hide') :
      header.addClass('sticky-hide').removeClass('sticky-show')
    this.oldScroll = this.scrollY
  })
}

export const selectNumbers = () => {
  $('.product__info--dose .product__content, .product__info--pack .product__content').html(function(i, v){
    v = v.replace(/g /g, 'g <br>').replace(/l /g, 'l <br>').replace(/- /g, '<br>').replace('<br><br>', '<br>').replace(/(\d+)/g, '<span class="number">$1</span>');
    return v.replace(/(<br>)+/g, '<br>');
  });
}

/* News ANIMATION
  ----------------------------- */

export const newsAnimation = () => {
  const $toggle = $('.preview--post')
  const $image = $('.preview__image')

  $toggle.mouseover(function() {
    $('preview__image').removeClass('transform');
    $( this ).find( ".preview__image" ).addClass('transform');
  })

  $toggle.mouseout(function() {
   $( this ).find( ".preview__image" ).removeClass('transform');
 })

  $(window).on('resize scroll', function() {
    $image.removeClass('transform')
  })
}


/* HEADER ANIMATION
  ----------------------------- */

export const childMenu = () => {
  const $toggle = $('.menu-item-has-children')
  const $submenu = $('.sub-menu')

  $toggle.mouseover(function() {
    $('.sub-menu').removeClass('open');
    $( this ).find( ".sub-menu" ).addClass('open');
  })

  $submenu.on('mouseleave', function() {
   $( this ).removeClass('open');
 })

  $(window).on('resize scroll', function() {
    $submenu.removeClass('open')
  })
}

/* SETUP MODALVIDEO
  ----------------------------- */
export const setupModalVideo = () => {
  if ($('.js-modal-btn').length > 0 || $('.js-modal-btn-vimeo').length > 0) {
    new ModalVideo('.js-modal-btn')
    new ModalVideo('.js-modal-btn-vimeo', { channel: 'vimeo' })
  }
}

/* SETUP SERVICE ACCORDION
  ----------------------------- */
export const setupServiceAccordion = () => {
  $(".section__repeater_accordion .item").each(function(index) {
    const $service = $(this)
    const h = $(this).find('.item__body--inner').innerHeight()

    $(this).find('.section__header .section__title').on('click', function(e) {
      if ($(this).parents('.item').hasClass('show')) {
        $(".item").removeClass('show').find('.item__body').css('max-height', 0)
      } else {
        $(".item").removeClass('show').find('.item__body').css('max-height', 0)
        $(this).parents('.item').addClass('show').find('.item__body').css('max-height', h)
      }
      e.preventDefault()
    })
  });
}



// WEBPACK FOOTER //
// ./src/js/functions.js